// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_task_status_enum */
var FermentationTaskStatusEnum;
(function (FermentationTaskStatusEnum) {
    FermentationTaskStatusEnum["PENDING"] = "PENDING";
    FermentationTaskStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    FermentationTaskStatusEnum["COMPLETED"] = "COMPLETED";
    FermentationTaskStatusEnum["SKIPPED"] = "SKIPPED";
    FermentationTaskStatusEnum["FAILED"] = "FAILED";
})(FermentationTaskStatusEnum || (FermentationTaskStatusEnum = {}));
;
export default FermentationTaskStatusEnum;
/** Zod schema for fermentation_task_status_enum */
export const fermentationTaskStatusEnum = z.nativeEnum(FermentationTaskStatusEnum);
//# sourceMappingURL=FermentationTaskStatusEnum.js.map